import { AccountLoginSecurityWebController } from '../controller/AccountLoginSecurityWebController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { AccountActionContext } from '../../types/AccountActionContext';
import { Observable } from 'rxjs';
import { AccountLoginSecurityData } from '../types';
import { CompanyData } from '../../types/CompanyData';

export class AccountLoginSecurityWebComponent extends BaseWebComponentElement {
  public controller!: AccountLoginSecurityWebController;
  private viewData: AccountLoginSecurityData;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AccountLoginSecurityWebController,
    });
  }

  public setViewData(accountLoginSecurityData: AccountLoginSecurityData): void {
    this.viewData = accountLoginSecurityData;
  }

  public getViewData(): AccountLoginSecurityData {
    return this.viewData;
  }

  public setActionContext(context: AccountActionContext): void {
    this.controller.view.context = context;
  }

  public updateSettingsDependingOnCompany(company: CompanyData): void {
    this.controller.view.updateSettingsDependingOnCompany(company);
  }

  public getPasswordLifetime(): boolean {
    return this.controller.view.dom.$passwordExpirationFormField.value as boolean;
  }

  public getAccountLockDown(): boolean {
    return this.controller.view.dom.$accountLockoutFormField.value as boolean;
  }

  public getConcurrentSessions(): boolean {
    return this.controller.view.dom.$concurrentSessionsFormField.value as boolean;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get valid(): boolean {
    if (!this.controller.view.formGroup) {
      return false;
    }
    return this.controller.view.formGroup.valid;
  }
}
